<template>
  <div class="search-form">
    <form
        action="/suche/"
        @submit.prevent="search"
    >
      <input
          placeholder="Dein Suchbegriff"
          type="text"
          v-model="form.query"
          @input="form.error = null"
      />
      <div
          v-if="form.error"
          class="io-search-form__error"
          v-html="form.error"
      ></div>
      <button
          type="submit"
          :title="canSearch ? `Nach '${form.query}' suchen` : 'Suchen'"
          :disabled="!canSearch"
      >
        <FontAwesomeIcon :icon="faSearch"/>
        <span class="sr-only">
          Suchen
        </span>
      </button>
    </form>
  </div>
</template>

<script lang="ts" setup>
import {
  computed,
  ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/pro-light-svg-icons';

library.add(faSearch);

const router = useRouter();
const emit = defineEmits(['search']);

const form = ref({
  query: null as string | null,
  error: null as string[] | null,
});

const canSearch = computed(() => `${form.value.query || ''}`.trim().length >= 2);

const search = () => {
  if (canSearch.value) {
    router.push(`/suche/?q=${form.value.query}`);
    emit('search', form.value.query);
  } else {
    form.value.error = ['Bitte Suchbegriff eingeben'];
  }
};

defineExpose({
  form,
});
</script>

<style scoped lang="scss">
@import "src/scss/component-helpers";

.search-form {
  border-radius: var(--card-border-radius);
  box-shadow: 0 2px 6px rgba(0, 0, 0, .16);
  max-width: 100%;
  background-color: #FFFFFF;
  overflow: hidden;
  position: relative;
  @include font-regular();

  button[type="submit"] {
    position: absolute;
    font-size: 1.5em;
    top: 0;
    right: 0;
    background: transparent;
    line-height: 1;
    padding: .796em 1em;
    border: 0;
    color: #000000;
    transition: opacity .275s ease;

    &:disabled {
      pointer-events: none;
      opacity: .59;
    }
  }

  input[type="text"] {
    font-size: inherit;
    padding: 1.375em 4.5em 1.375em 1.5em;
    width: 100%;
    border: 0;
    outline: 0;
    line-height: 1;

    ::placeholder,
    :-ms-input-placeholder,
    ::-ms-input-placeholder {
      color: #7C7C7C;
      opacity: 1;
    }
  }
}
</style>
